import { render, staticRenderFns } from "./PersonalDataSoloRequired.vue?vue&type=template&id=6edc9780&scoped=true"
import script from "./PersonalDataSoloRequired.vue?vue&type=script&lang=js"
export * from "./PersonalDataSoloRequired.vue?vue&type=script&lang=js"
import style0 from "./PersonalDataSoloRequired.vue?vue&type=style&index=0&id=6edc9780&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6edc9780",
  null
  
)

export default component.exports